import { BasicReflectionEvent } from './basicReflectionEvent';
export class LowReflectionEvent extends BasicReflectionEvent {
    constructor(previousSite, targetSide, site) {
        super(previousSite.ReflectingObstacle, targetSide.obstacle, site);
        this.Side = targetSide;
    }
}
//# sourceMappingURL=LowReflectionEvent.js.map